import Modal from 'react-modal';
import React from 'react';
import defaultTheme from 'design-system/src/Theme/defaultTheme';
import Typography from 'design-system/src/Components/Typography/Typography.web';
import {Pressable} from 'react-native';
import Icon from 'design-system/src/Components/Icon/Icon';
import Button from 'design-system/src/Components/Button/Button';
import Metrics from 'design-system/src/Theme/Metrics';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  loading?: boolean;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  loading = false,
}: ConfirmationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      appElement={document.getElementById('root') as HTMLElement}
      overlayElement={(d, contentElement) => (
        <div
          {...d}
          style={{
            ...d.style,
            background: 'rgba(17, 18, 22, 0.60)',
            backdropFilter: 'blur(10px)',
            zIndex: 11000,
          }}>
          {contentElement}
        </div>
      )}
      style={{
        content: {
          border: 'none',
          background: 'transparent',
          padding: 0,
          margin: 'auto',
          width: 'fit-content',
          height: 'fit-content',
          inset: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        overlay: {
          background: 'rgba(17, 18, 22, 0.60)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: defaultTheme.page.background,
          borderRadius: 8,
          padding: 20,
          minWidth: 300,
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: Metrics.verticalScale(16),
          }}>
          <Typography variant="h3" style={{color: 'white'}}>
            {title}
          </Typography>
          <Pressable onPress={onClose}>
            <Icon name="close" color="white" />
          </Pressable>
        </div>
        <div style={{marginBottom: Metrics.verticalScale(32)}}>
          <Typography variant="body2">{message}</Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 40,
            padding: 20,
          }}>
          <Button
            variant="contained"
            size="small"
            title={cancelText}
            fullWidth
            onPress={onClose}
            style={{
              backgroundColor: 'transparent',
            }}
            disabled={loading}
          />
          <Button
            variant="contained"
            size="small"
            title={confirmText}
            fullWidth
            onPress={onConfirm}
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
